import script from "./menu-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu-button.vue?vue&type=script&setup=true&lang=ts"

import "./menu-button.vue?vue&type=style&index=0&id=0e2fb800&lang=scss"

const __exports__ = script;

export default __exports__